window.onload = function() {
      updateSwitches();
      updateMRP();
      updatePrices();
};

  document.querySelectorAll('input[name="house_type"]').forEach(radio => {
    radio.addEventListener('change', function () {
      const selectedValue = this.value;
      const url = new URL(window.location.href);
      url.searchParams.set('house_type', selectedValue);
      window.location.href = url; // Redirect with query parameter
    });
  });

  // Preselect the radio button based on query parameter
  const params = new URLSearchParams(window.location.search);
  const selectedHouseType = params.get('house_type');
  if (selectedHouseType) {
    const selectedRadio = document.querySelector(`input[value="${selectedHouseType}"]`);
    if (selectedRadio) {
      selectedRadio.checked = true;
    }
  }
//Default values of bhks

document.addEventListener('DOMContentLoaded', () => {
  const radioButtons = document.querySelectorAll('input[type="radio"][name="house_type"]');
  
  const updateColors = () => {
    radioButtons.forEach((radio) => {
      const span = radio.nextElementSibling;
      if (radio.checked) {
        span.style.color = 'black';
        span.style.fontWeight = 'bold';
      } else {
        span.style.color = 'grey';
        span.style.fontWeight = 'normal';
      }
    });
  };

  updateColors();
  radioButtons.forEach((radio) => {
    radio.addEventListener('change', updateColors);
  });
});

// Spinner Logic
document.querySelectorAll('.custom-spinner-container').forEach((spinner, index) => {
  const valueElement = spinner.querySelector('.spinner-value');
  const upArrow = spinner.querySelector('.up-arrow');
  const downArrow = spinner.querySelector('.down-arrow');

  let defaultValue;
  // Function to set the default value based on selected house type
  const setDefaultValue = () => {
    const selectedHouseType = document.querySelector('input[name="house_type"]:checked').value;

    if (selectedHouseType === '2BHK') {
       
      if (index === 0 || index === 1 || index === 3 || index === 4 || index === 6 || index === 9 || index === 18) {
        defaultValue = 1;
      }
      else if (index === 12 || index === 13 || index === 15) {
        defaultValue = 3;
      }
    } else if (selectedHouseType === '3BHK') {
      
      if (  index === 1 || index === 3 || index === 4 || index === 6 || index === 9 || index === 18) {
        defaultValue = 2; // Change the value as per your requirement for 3BHK
      }
      else if (index === 12 || index === 13 || index === 15) {
        defaultValue = 3; // Adjust for 3BHK accordingly
      } else if(index === 0){ defaultValue = 1;}
    } else if (selectedHouseType === '4BHK') {
      if (  index === 1 || index === 3 || index === 4 || index === 6 || index === 9 || index === 18) {
        defaultValue = 2; // Change the value as per your requirement for 3BHK
      }
      else if (index === 12 || index === 13 || index === 15) {
        defaultValue = 4; // Adjust for 3BHK accordingly
      } else if(index === 0){ defaultValue = 1;}
    } else if (selectedHouseType === '5BHK') {
     if (  index === 1 || index === 3 || index === 4 || index === 6 || index === 9 || index === 18) {
        defaultValue = 3; // Change the value as per your requirement for 3BHK
      }
      else if (index === 12 || index === 13 || index === 15) {
        defaultValue = 5; // Adjust for 3BHK accordingly
      } else if(index === 0){ defaultValue = 1;} // Modify based on 5BHK
    }

    if (isNaN(defaultValue)) defaultValue = 0;
    valueElement.textContent = defaultValue;
  };

  // Set default value on page load
  setDefaultValue();

  // Listen for changes in radio button selection
  document.querySelectorAll('input[name="house_type"]').forEach(radio => {
    radio.addEventListener('change', setDefaultValue);
  });

  // Update the count based on arrow clicks
  upArrow.addEventListener('click', () => updateCount(valueElement, true));
  downArrow.addEventListener('click', () => updateCount(valueElement, false));
  
});

document.addEventListener('DOMContentLoaded', () => {
  // Your other setup code...

  // Initialize spinner button listeners just once
  document.querySelectorAll('.custom-spinner-container .spinner-btn').forEach(button => {
    button.addEventListener('click', handleSpinnerClick);
  });

  // Function to handle spinner button clicks (increment/decrement)
  function handleSpinnerClick(e) {
    const spinnerValueElement = e.target.closest('.custom-spinner-container').querySelector('.spinner-value');
    let value = parseInt(spinnerValueElement.textContent || '0', 10);


    // Recalculate and update the switches table based on the new value
    updateSwitches();
    // Recalculate the MRP (price) based on the updated spinner values
    updateMRP();
  }
});

const updateSwitches = () => {
  const selectedSwitches = [];
  const switchElements = document.querySelectorAll('.select-type');

  switchElements.forEach((select, index) => {
    const roomName = `Room ${index + 1}`;
    const switchType = select.value;
    const count = parseInt(
      select.closest('td').nextElementSibling.querySelector('.spinner-value').textContent || '0',
      10
    );

    if (switchType && count > 0) {
      selectedSwitches.push({ room: roomName, switchType, count });
    }
  });

  // Classify switches into modules
  const moduleMapping = {
    '2 module': ['2S', '2M4S', 'Curtain', '1S', '1D', 'Doorbell'],
    '3 module': ['3S', '1P'],
    '4 module': ['4S', '4M6S', '3S1F', '3S1D', '1S1P'],
    '8 module': ['6S2F', '7S1F', '8S', '3S1F1P', '4S1P', '2S2P', '7S1D', '6S1D1F', '6S2D', '3S1D1P', '2P'],
    '12 module': ['6S2F2P', '7S1F2P', '8S2P'],
  };

  const moduleCounts = {};

  selectedSwitches.forEach(({ switchType, count }) => {
    for (const [module, types] of Object.entries(moduleMapping)) {
      if (types.includes(switchType)) {
        moduleCounts[module] = (moduleCounts[module] || 0) + count;
        break;
      }
    }
  });

  // Update the div layout for modules
  const moduleBody = document.getElementById('module-body');
  if (moduleBody) {
    moduleBody.innerHTML = ''; // Clear existing rows before adding new ones

    // Ensure the default modules (2, 4, 8, 12) are always displayed
    const defaultModules = ['2 module', '3 module', '4 module', '8 module', '12 module'];
    let totalSwitches = 0;

    // Add default modules first, even if the count is 0
    defaultModules.forEach(module => {
      const row = document.createElement('div');
      row.className = 'module-row';

      const moduleCell = document.createElement('div');
      moduleCell.className = 'module-cell';
      moduleCell.textContent = module;
      row.appendChild(moduleCell);

      const countCell = document.createElement('div');
      countCell.className = 'module-cell';
      countCell.innerHTML = `<strong>${moduleCounts[module] || 0}</strong>`;
      row.appendChild(countCell);

      moduleBody.appendChild(row);

      totalSwitches += moduleCounts[module] || 0;
    });
 // Add a separator line above the total row
    const separator = document.createElement('div');
    separator.className = 'module-separator';
    separator.style.borderTop = '2px solid black';
    separator.style.margin = '10px 0';
    moduleBody.appendChild(separator);

    // Add the total row at the end
    const totalRow = document.createElement('div');
    totalRow.className = 'module-row';

    const totalLabel = document.createElement('div');
    totalLabel.className = 'module-cell';
    totalLabel.textContent = 'Total Switches ';
    totalRow.appendChild(totalLabel);

    const totalCountCell = document.createElement('div');
    totalCountCell.className = 'module-cell';
    totalCountCell.innerHTML = `<strong style="color:black">${totalSwitches}</strong>`;
    totalRow.appendChild(totalCountCell);

    moduleBody.appendChild(totalRow);
  }
};

// Function to update MRP (total price) based on selected switches and their counts
function updateMRP() {
  let totalMRP = 0;
  const selectedSwitches = [];
  const switchTypeDropdowns = document.querySelectorAll('.select-type');
  const spinners = document.querySelectorAll('.spinner-value');

  switchTypeDropdowns.forEach(function(dropdown, index) {
    const selectedValue = dropdown.value;
    const count = parseInt(spinners[index].textContent) || 1;

    if (selectedValue && manualPrices[selectedValue]) {
      totalMRP += manualPrices[selectedValue] * count;
      selectedSwitches.push(`${selectedValue} (x${count})`);
    }
  });

  const mrpElement = document.getElementById('mrp');
  const selectedSwitchNames = selectedSwitches.join(', ');
  if (mrpElement) {
    mrpElement.innerHTML = `₹${totalMRP.toFixed(2)} <br> <span style="font-size: 12px; color: #555;">(${selectedSwitchNames})</span>`;
  }
}
// Function to update MRP (total price) based on selected switches and their counts
function updateTotal() {
  let total = 0;
  const selectedSwitches = [];
  const switchTypeDropdowns = document.querySelectorAll('.select-type');
  const spinners = document.querySelectorAll('.spinner-value');

  switchTypeDropdowns.forEach(function(dropdown, index) {
    const selectedValue = dropdown.value;
    const count = parseInt(spinners[index].textContent) || 1;

    if (selectedValue && DIDPrices[selectedValue]) {
      total += DISPrices[selectedValue] * count;
      selectedSwitches.push(`${selectedValue} (x${count})`);
    }
  });

  const totalElement = document.getElementById('Final');
  const selectedSwitchNames = selectedSwitches.join(', ');
  if (totalElement) {
    totalElement.innerHTML = `₹${total.toFixed(2)} <br> <span style="font-size: 12px; color: #555;">(${selectedSwitchNames})</span>`;
  }
}
function handleSpinnerClick(e) {
  const spinnerValueElement = e.target.closest('.spinner-buttons').previousElementSibling;
  let value = parseInt(spinnerValueElement.textContent || '0', 10);

  if (e.target.classList.contains('spinner-increment')) {
    value += 1;  // Increment the value by 1
  } else if (e.target.classList.contains('spinner-decrement')) {
    value -= 1;  // Decrement the value by 1
  }

  // Update the spinner value in the UI
  spinnerValueElement.textContent = value;

  // Update the switches table with the new value
  updateSwitches();
}
document.addEventListener('DOMContentLoaded', function() {
  // Set the default values based on the initially selected BHK (2BHK in this case)
  setDropdownOptions('2BHK');
  
  // Event listener for house type radio buttons
  const houseTypeRadios = document.querySelectorAll('input[name="house_type"]');
  houseTypeRadios.forEach(function(radio) {
    radio.addEventListener('change', function(event) {
      setDropdownOptions(event.target.value);
    });
  });


 const resetButton = document.getElementById('reset-button');
resetButton.addEventListener('click', function() {
  // Reset other elements like count, if applicable
  const mrp = document.getElementById('mrp').textContent="0";
   const dis = document.getElementById('discount').textContent="0";
   const final = document.getElementById('Final').textContent="0";
  const spinners = document.querySelectorAll('.spinner-value');
  spinners.forEach(function(spinner) {
    spinner.textContent = '0'; // Assuming default count is 0
  });
              updateSwitches();

});

  // Function to set dropdown options based on the selected house type
  function setDropdownOptions(houseType) {
    // Select all rows in the table (excluding the first header row)
    const roomRows = document.querySelectorAll('tr');
    roomRows.forEach(function(row, index) {
      if (index > 0) { // Skip the header row
        const dropdowns = row.querySelectorAll('.select-type');
        
        // Set the dropdown values based on houseType
        if (houseType === '2BHK') {
          if (index === 1) {
            dropdowns[0].value = 'Doorbell';
            dropdowns[1].value = '2S';
          }
          else if(index === 2){
            dropdowns[0].value = '6S2F';
            dropdowns[1].value = '4S1P';
          }
          else if(index === 3){
            dropdowns[0].value = '7S1F';
          }
          else if(index === 4){
            dropdowns[0].value = '3S1F1P';
          }
          else if(index === 5){
            dropdowns[0].value = '7S1F';
            dropdowns[1].value = '4S1P';
          }
          else if(index === 6){
            dropdowns[0].value = '4S';
          }
          else if(index === 7){
            dropdowns[0].value = '4S';
          }
        } else if (houseType === '3BHK') {
          if (index === 1) {
            dropdowns[0].value = '2S';
          }
          else if(index === 2){
            dropdowns[0].value = '6S2F';
          }
          else if(index === 3){
            dropdowns[0].value = '7S1F';
          }
          else if(index === 4){
            dropdowns[0].value = '3S1F1P';
          }
          else if(index === 5){
            dropdowns[0].value = '7S1F';
          }
          else if(index === 6){
            dropdowns[0].value = '4S';
          }
          else if(index === 7){
            dropdowns[0].value = '4S';
          }
        } else if (houseType === '4BHK') {
          if (index === 1) {
            dropdowns[0].value = 'Doorbell';
            dropdowns[1].value = '2S';
          }
          else if(index === 2){
            dropdowns[0].value = '6S2F';
          }
          else if(index === 3){
            dropdowns[0].value = '7S1F';
          }
          else if(index === 4){
            dropdowns[0].value = '3S1F1P';
          }
          else if(index === 5){
            dropdowns[0].value = '7S1F';
          }
          else if(index === 6){
            dropdowns[0].value = '4S';
          }
          else if(index === 7){
            dropdowns[0].value = '4S';
          }
        } else if (houseType === '5BHK') {
          if (index === 1) {
            dropdowns[0].value = '2S';
          }
          else if(index === 2){
            dropdowns[0].value = '6S2F';
          }
          else if(index === 3){
            dropdowns[0].value = '7S1F';
          }
          else if(index === 4){
            dropdowns[0].value = '3S1F1P';
          }
          else if(index === 5){
            dropdowns[0].value = '7S1F';
          }
          else if(index === 6){
            dropdowns[0].value = '4S';
          }
          else if(index === 7){
            dropdowns[0].value = '4S';
          }
        }
      }
    });
  }  
   
});

document.addEventListener("DOMContentLoaded", function() {
  // Manual price list for each switch type
  const manualPrices = {
    "1S": 5900,
    "1D": 5900,
    "Doorbell": 2950,
    "2S": 6490,
    "2M4S": 7080, 
    "Curtain": 6490,
    "3S": 7670,
    "1P": 7670,
    "4S": 7670,
    "4M6S": 8260,
    "3S1F": 7670,
    "3S1D": 7670,
    "1S1P": 7670,
    "8M12S": 11210,
    "7S1F": 9950,
    "8S": 9950,
    "6S2F": 9950,
    "6S1P": 10620,
    "5S1F1P": 10620,
    "3S1F1P": 9950,
    "4S1P": 9950,
    "2S2P": 9950,
    "7S1D": 9950,
    "6S1D1F": 9950,
    "6S2D": 9950,
    "5S1D1P": 10620,
    "3S1D1P": 9950,
    "2P": 9950,
    "12S2P": 14160,
    "6S2F2P": 13511,
    "7S1F2P": 13511,
    "8S2P": 13511
  };

  const DISPrices = {
    "1S": 4720,
    "1D": 4720,
    "Doorbell": 2360,
    "2S": 5192,
    "2M4S": 5664,
    "Curtain": 5192,
    "3S": 6136,
    "1P": 6136,
    "4S": 6136,
    "4M6S": 6608,
    "3S1F": 6136,
    "3S1D": 6136,
    "1S1P": 6136,
    "8M12S": 8968,
    "7S1F": 7960,
    "8S": 7960,
    "6S1P": 8496,
    "5S1F1P": 8496,
    "6S2F": 7960,
    "3S1F1P": 7960,
    "4S1P": 7960,
    "2S2P": 7960,
    "7S1D": 7960,
    "6S1D1F": 7960,
    "6S2D": 7960,
    "5S1D1P": 8496,
    "3S1D1P": 7960,
    "2P": 7960,
    "12S2P": 11328,
    "6S2F2P": 10808.80,
    "7S1F2P": 10808.80,
    "8S2P": 10808.80
  };

  // Function to safely retrieve the spinner count
  function getSpinnerCount(spinnerElement) {
    const count = parseInt(spinnerElement?.textContent.trim()) || 0; // Default to 1 if invalid
    return count;
  }

  // Function to update MRP and total
  function updatePrices() {
    let totalMRP = 0;
    let totalTotal = 0;
    const selectedSwitches = [];
    
    // Select all dropdowns and spinners dynamically
    const switchTypeDropdowns = document.querySelectorAll('.select-type');
    const spinners = document.querySelectorAll('.spinner-value');

    // Loop through all switch type dropdowns
    switchTypeDropdowns.forEach(function(dropdown, index) {
      const selectedValue = dropdown.value;
      const count = getSpinnerCount(spinners[index]); // Get count for the switch type

      if (selectedValue && manualPrices[selectedValue] && DISPrices[selectedValue]) {
        // Add the price multiplied by the count to MRP and DISPrices
        totalMRP += manualPrices[selectedValue] * count;
        totalTotal += DISPrices[selectedValue] * count;
        selectedSwitches.push(`${selectedValue} (x${count})`);
      }
    });

    // Display the MRP and selected switch names
    const formatter = new Intl.NumberFormat('en-IN'); // For Indian formatting
    const formattedMRP = formatter.format(totalMRP);
    const formattedTotal = formatter.format(totalTotal);
    const discount = totalMRP - totalTotal;
    const formattedDiscount = formatter.format(discount);

    // Display the MRP
    const mrpElement = document.getElementById('mrp');
    if (mrpElement) {
      mrpElement.innerHTML = `₹${formattedMRP}`;
    }

    // Display the total price
    const totalElement = document.getElementById('Final');
    if (totalElement) {
      totalElement.innerHTML = `₹${formattedTotal}`;
    }

    // Display the discount
    const discountElement = document.getElementById('discount');
    if (discountElement) {
      discountElement.innerHTML = `₹${formattedDiscount}`;
    }
  }

  // Add event listeners to each dropdown and spinner to trigger price updates
  function attachEventListeners() {
    // Select all dropdowns for switch types and spinners
    const switchTypeDropdowns = document.querySelectorAll('.select-type');
    const spinners = document.querySelectorAll('.spinner-value');

    switchTypeDropdowns.forEach(function(dropdown) {
      dropdown.addEventListener('change', updatePrices);
    });

    spinners.forEach(function(spinner) {
      const upButton = spinner.closest('.custom-spinner-container').querySelector('.up-arrow');
      const downButton = spinner.closest('.custom-spinner-container').querySelector('.down-arrow');

      // Increment spinner value
      upButton.addEventListener('click', function() {
        let currentValue = parseInt(spinner.textContent) || 0;
        spinner.textContent = currentValue + 1;
        updatePrices();
         updateSwitches();

      });

      // Decrement spinner value
      downButton.addEventListener('click', function() {
        let currentValue = parseInt(spinner.textContent) || 0;
        if (currentValue > 0) {
          spinner.textContent = currentValue - 1;
          updatePrices();
           updateSwitches();


        }
      });
    });
  }

  // Initialize prices on page load
           updateSwitches();

  updatePrices();
  attachEventListeners();

  document.getElementById('add-new-row').addEventListener('click', function () {
    const tableBody = document.querySelector('table tbody');
    const newRow = document.createElement('tr');

    // Create a new row content dynamically
    newRow.innerHTML = `
      <td>
        <div class="icon-text-wrapper">
          <img src="https://cdn.shopify.com/s/files/1/0890/5582/2142/files/Component_1_7.png?v=1734606706" alt="New Room icon" />
          <span>New Room</span>
        </div>
      </td>
      <td class="type-switches">
        <div class="custom-select-container">
          <select name="switch_type_1" class="select-type">
             <option value="Doorbell">Doorbell</option>
              <option value="2S">2S</option>
              <option value="2M4S">2M4S</option>
              <option value="1S">1S</option>
              <option value="1D">1D</option>
              <option value="Curtain">Curtain</option>
              <option value="4S">4S</option>
              <option value="4M6S">4M6S</option>
              <option value="3S1F">3S1F</option>
              <option value="3S1D">3S1D</option>
              <option value="1S1P">1S1P</option>
              <option value="3S">3S</option>
              <option value="1P">1P</option>
              <option value="8M12S">8M12S</option>
              <option value="6S2F">6S2F</option>
              <option value="7S1F">7S1F</option>
              <option value="8S">8S</option>
              <option value="6S1P">6S1P</option>
              <option value="5S1F1P">5S1F1P</option>
              <option value="3S1F1P">3S1F1P</option>
              <option value="4S1P">4S1P</option>
              <option value="2S2P">2S2P</option>
              <option value="7S1D">7S1D</option>
              <option value="6S1D1F">6S1D1F</option>
              <option value="6S2D">6S2D</option>
              <option value="5S1D1P">5S1D1P</option>
              <option value="3S1D1P">3S1D1P</option>
              <option value="2P">2P</option>
              <option value="6S2F2P">6S2F2P</option>
              <option value="7S1F2P">7S1F2P</option>
              <option value="8S2P">8S2P</option>
          </select>
        </div>
      </td>
      <td>
        <div class="custom-spinner-container">
          <span class="spinner-value">1</span>
          <div class="spinner-buttons">
            <button class="spinner-btn up-arrow"><i class="arrow up"></i></button>
            <button class="spinner-btn down-arrow"><i class="arrow down"></i></button>
          </div>
        </div>
      </td>
      <td class="type-switches">
        <div class="custom-select-container">
          <select name="switch_type_2" class="select-type">
            <option value="Doorbell">Doorbell</option>
              <option value="2S">2S</option>
              <option value="2M4S">2M4S</option>
              <option value="1S">1S</option>
              <option value="1D">1D</option>
              <option value="Curtain">Curtain</option>
              <option value="4S">4S</option>
              <option value="4M6S">4M6S</option>
              <option value="3S1F">3S1F</option>
              <option value="3S1D">3S1D</option>
              <option value="1S1P">1S1P</option>
              <option value="3S">3S</option>
              <option value="1P">1P</option>
              <option value="8M12S">8M12S</option>
              <option value="6S2F">6S2F</option>
              <option value="7S1F">7S1F</option>
              <option value="8S">8S</option>
              <option value="6S1P">6S1P</option>
              <option value="5S1F1P">5S1F1P</option>
              <option value="3S1F1P">3S1F1P</option>
              <option value="4S1P">4S1P</option>
              <option value="2S2P">2S2P</option>
              <option value="7S1D">7S1D</option>
              <option value="6S1D1F">6S1D1F</option>
              <option value="6S2D">6S2D</option>
              <option value="5S1D1P">5S1D1P</option>
              <option value="3S1D1P">3S1D1P</option>
              <option value="2P">2P</option>
              <option value="6S2F2P">6S2F2P</option>
              <option value="7S1F2P">7S1F2P</option>
              <option value="8S2P">8S2P</option>
          </select>
        </div>
      </td>
      <td>
        <div class="custom-spinner-container">
          <span class="spinner-value">1</span>
          <div class="spinner-buttons">
            <button class="spinner-btn up-arrow"><i class="arrow up"></i></button>
            <button class="spinner-btn down-arrow"><i class="arrow down"></i></button>
          </div>
        </div>
      </td>
      <td class="type-switches">
        <div class="custom-select-container">
          <select name="switch_type_3" class="select-type">
             <option value="Doorbell">Doorbell</option>
              <option value="2S">2S</option>
              <option value="2M4S">2M4S</option>
              <option value="1S">1S</option>
              <option value="1D">1D</option>
              <option value="Curtain">Curtain</option>
              <option value="4S">4S</option>
              <option value="4M6S">4M6S</option>
              <option value="3S1F">3S1F</option>
              <option value="3S1D">3S1D</option>
              <option value="1S1P">1S1P</option>
              <option value="3S">3S</option>
              <option value="1P">1P</option>
              <option value="8M12S">8M12S</option>
              <option value="6S2F">6S2F</option>
              <option value="7S1F">7S1F</option>
              <option value="8S">8S</option>
              <option value="6S1P">6S1P</option>
              <option value="5S1F1P">5S1F1P</option>
              <option value="3S1F1P">3S1F1P</option>
              <option value="4S1P">4S1P</option>
              <option value="2S2P">2S2P</option>
              <option value="7S1D">7S1D</option>
              <option value="6S1D1F">6S1D1F</option>
              <option value="6S2D">6S2D</option>
              <option value="5S1D1P">5S1D1P</option>
              <option value="3S1D1P">3S1D1P</option>
              <option value="2P">2P</option>
              <option value="6S2F2P">6S2F2P</option>
              <option value="7S1F2P">7S1F2P</option>
              <option value="8S2P">8S2P</option>
          </select>
        </div>
      </td>
      <td>
        <div class="custom-spinner-container">
          <span class="spinner-value">1</span>
          <div class="spinner-buttons">
            <button class="spinner-btn up-arrow"><i class="arrow up"></i></button>
            <button class="spinner-btn down-arrow"><i class="arrow down"></i></button>
          </div>
        </div>
      </td>
    `;

    // Append the new row to the table
    tableBody.appendChild(newRow);
           updateSwitches();

    // Recalculate prices after adding a new row
    updatePrices();
    // Reattach event listeners for the new spinners and dropdowns
    attachEventListeners();
  });
});


//form popup open 
document.addEventListener("DOMContentLoaded", function () {
    var openPopupButton = document.getElementById("openPopup");
    var closePopupButton = document.getElementById("closePopup");
    var popupOverlay = document.getElementById("contactPopup");
    var selectedSwitchesDiv = document.getElementById("selectedSwitches");

    // Check if elements exist before adding event listeners
    if (!openPopupButton || !closePopupButton || !popupOverlay) {
        console.error("Popup elements not found in the DOM!");
        return;
    }

    // Function to Get Selected Switches
    function getSelectedSwitches() {
        const selectedSwitches = [];
        const switchElements = document.querySelectorAll('.select-type');

        switchElements.forEach((select, index) => {
            const roomName = `Room ${index + 1}`;
            const switchType = select.value;
            const count = parseInt(
                select.closest('td').nextElementSibling.querySelector('.spinner-value')?.textContent || '0',
                10
            );

            if (switchType && count > 0) {
                selectedSwitches.push(` ${switchType} (x${count})`);
            }
        });

        return selectedSwitches;
    }

    // Open Popup and Display Selected Switches (Comma-Separated)
    openPopupButton.addEventListener("click", function () {
        let selectedSwitches = getSelectedSwitches();
        
        if (selectedSwitches.length > 0) {
            selectedSwitchesDiv.innerHTML = `<strong>Selected Switches:</strong> ${selectedSwitches.join(", ")}`;
        } else {
            selectedSwitchesDiv.innerHTML = "<em>No switches selected.</em>";
        }

        popupOverlay.style.display = "flex";
    });

    // Close Popup
    closePopupButton.addEventListener("click", function () {
        popupOverlay.style.display = "none";
    });

    // Close when clicking outside the popup
    popupOverlay.addEventListener("click", function (event) {
        if (event.target === popupOverlay) {
            popupOverlay.style.display = "none";
        }
    });

   
});


//form popup open 
document.addEventListener("DOMContentLoaded", function () {
    var openPopupButton = document.getElementById("openPopup");
    var closePopupButton = document.getElementById("closePopup");
    var popupOverlay = document.getElementById("contactPopup");
    var selectedSwitchesDiv = document.getElementById("selectedSwitches");
    var hiddenSwitchesInput = document.getElementById("hiddenSwitches");

    // Check if elements exist before adding event listeners
    if (!openPopupButton || !closePopupButton || !popupOverlay) {
        console.error("Popup elements not found in the DOM!");
        return;
    }

    // Function to Get Selected Switches
    function getSelectedSwitches() {
        const selectedSwitches = [];
        const switchElements = document.querySelectorAll('.select-type');

        switchElements.forEach((select, index) => {
            const roomName = `Room ${index + 1}`;
            const switchType = select.value;
            const count = parseInt(
                select.closest('td').nextElementSibling.querySelector('.spinner-value')?.textContent || '0',
                10
            );

            if (switchType && count > 0) {
                selectedSwitches.push(`${switchType} - <strong style="color:#283593">(x${count})</strong>`);
            }
        });

        return selectedSwitches;
    }

    // Open Popup and Display Selected Switches (Comma-Separated)
    openPopupButton.addEventListener("click", function () {
        let selectedSwitches = getSelectedSwitches();
        
        if (selectedSwitches.length > 0) {
            selectedSwitchesDiv.innerHTML = `<strong style="font-size:18px" >Selected Switches:</strong> ${selectedSwitches.join(", ")}`;
        } else {
            selectedSwitchesDiv.innerHTML = "<em>No switches selected.</em>";
        }
       hiddenSwitchesInput.value = selectedSwitches.join(", ");
        popupOverlay.style.display = "flex";
    });

    // Close Popup
    closePopupButton.addEventListener("click", function () {
        popupOverlay.style.display = "none";
    });

    // Close when clicking outside the popup
    popupOverlay.addEventListener("click", function (event) {
        if (event.target === popupOverlay) {
            popupOverlay.style.display = "none";
        }
    });

   
});
